import { createSlice } from "@reduxjs/toolkit";

export const billingSlice= createSlice({
    name:"billing",
    initialState:{
        billingList:{}

    },
    reducers:{
        setBillingList:(state,action)=>{
            state.billingList = action.payload;
        }
    }
})

export const {setBillingList} = billingSlice.actions;
export default billingSlice.reducer; 